import { DesignWebpackBackend } from '@sas/react-svg';
import { BackendModule, Services, InitOptions, ReadCallback } from 'i18next';
import { getBundle } from './createUseTextLocalizer';
import { CompatibleMessageBundle } from './MessageBundle';

/**
 * Abstract I18next backend for loading message bundles with webpack.
 */
export default abstract class WebpackBackend implements BackendModule {
  readonly type = 'backend';

  constructor() {}

  init(_services: Services, _backendOptions: object, _i18nextOptions: InitOptions): void {}

  async read(language: string, namespace: string, callback: ReadCallback) {
    try {
      callback(null, await this.import(language, namespace));
    } catch (err: any) {
      callback(err, false);
    }
  }

  create(_languages: string[], _namespace: string, _key: string, _fallbackValue: string): void {}

  abstract import(language: string, bundleName: string): Promise<CompatibleMessageBundle>;
}

/**
 * I18next backend to load default message bundles for nova-commons components.
 *
 * All apps should include this unless you have a VERY unique i18n use case.
 */
export class NovaWebpackBackend extends WebpackBackend {
  readonly defaultProvider = true;
  async import(language: string, bundleName: string) {
    if (bundleName.startsWith('SASDesign-')) {
      return await new DesignWebpackBackend().import(language, bundleName);
    }

    if (language !== 'en') {
      // eslint-disable-next-line @sas/i18n/jsx-to-localize
      return Promise.reject('Only en is supported by NovaWebpackBackend');
    }

    const bundle = getBundle(bundleName);
    if (bundle) {
      return bundle;
    }

    // eslint-disable-next-line @sas/i18n/jsx-to-localize
    return Promise.reject(`Bundle'${bundleName}' not found in NovaWebpackBackend.`);
  }
}
